export default "/fonts/fa-brands-400.woff2?3ac6859b28be946745f95de1136a7251";